export function getIndicatorInputRange(length: number) {
  // Uncaught Invariant Violation: inputRange must have at least 2 elements.
  const safeLength = Math.max(2, length);

  return new Array(safeLength).fill('').reduce<number[]>((acc, _cur, index) => {
    const isLast = index === safeLength - 1;

    return isLast
      ? acc.concat(index)
      : // 每個數字間都得加上 0.01 與 0.99 來幫助動畫滑順
        acc.concat(index, index + 0.01, index + 0.99);
  }, []);
}
